// ØČËĀŃ archive data.

const IMG = "https://static.prod-images.emergentagent.com/jobs/dd5b8c70-7469-47de-8b04-9f42bfb30582/images";

export const HERO_IMAGE = `${IMG}/4b8f00b144001b73a0ab66cffdbc1e81d8071c8a7c1a7049e159a2c523aaaaa3.jpeg`;

export const LOGO_EMBLEM = "https://customer-assets-jt897jd0.emergentagent.net/job_dd5b8c70-7469-47de-8b04-9f42bfb30582/artifacts/m2lq6t9d_IMG_7220.png";
export const LOGO_WORDMARK = "https://customer-assets-jt897jd0.emergentagent.net/job_dd5b8c70-7469-47de-8b04-9f42bfb30582/artifacts/oksdupd3_IMG_7232.png";

const A = "https://customer-assets-jai6qajn.emergentagent.net/job_sonic-archive-10/artifacts";

export const fullAlbums = [
  {
    id: "hearts-vol-1",
    title: "HEARTS WERE MADE TO BE BROKEN VOL. 1",
    format: "THE ONE THAT GOT AWAY",
    accent: "#C22240",
    cover: `${A}/t6sz8ns3_Grey_Black_Vintage_Texture_Album_Cover.jpeg`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/wW1aUgpwHtOVPJBvtf4fu",
    tag: "VOLUME I",
    world: "Volume one of a habit that keeps repeating. Rain on the glass, taillights getting smaller, the person you rebuild in your head every night. Not sadness exactly. A memory that refuses to update.",
    lore: [
      "Volume one of something that keeps happening. The specific person you rebuild every night, edited slightly better each time.",
      "Not grief. Maintenance. A memory you keep polishing instead of putting down. The record treats one goodbye like a room you can walk back into whenever you want.",
    ],
  },
  {
    id: "the-broken-lp",
    title: "SHATTERED EMOTIONS LP",
    format: "THE HEARTBREAK COLLECTIVE",
    accent: "#9A1526",
    cover: `${A}/y5064dvt_IMG_7252.png`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/fz9qIWAKe88KmWoWcRxm1",
    tag: "COLLECTIVE",
    world: "Not one heartbreak. Everyone's. A body split down the middle, holding its own heart above the water, unsure whether to save it or let it sink. The sound of people who came apart and kept walking.",
    lore: [
      "Not one heartbreak. A collection. Different people, the same fracture, gathered into one body of sound.",
      "The figure on the cover holds its own heart above the water and cannot decide whether to save it or let it sink. Neither can the record. It sits in that hesitation for the whole runtime.",
    ],
  },
];

export const instrumentalAlbums = [
  {
    id: "conversation-with-god",
    title: "CONVERSATION WITH GOD EP",
    format: "EP",
    accent: "#C9A96A",
    cover: `${A}/cn3srvje_IMG_7165.jpeg`,
    preview: "https://customer-assets-jai6qajn.emergentagent.net/job_sonic-archive-10/artifacts/zb56h60c_CONVERSATION%20WITH%20GOD%20PREVIEW.wav",
    stream: null,
    url: "https://untitled.stream/buy/project/0RZhmDCuJKWs1m2SP1aXE",
    tag: "SPIRITUAL",
    world: "Strings folded into tape hiss, asking questions too large for language. Every phrase climbs upward and comes back changed. You are not here to find the answer. You are here to sit inside the asking.",
    lore: [
      "It started as one long question and never really resolved. The harmony keeps drifting a half-step out of reach, the way an answer does when you get close to it.",
      "There is no sermon here. Just the sound of someone talking to the ceiling at four in the morning and meaning every word.",
    ],
  },
  {
    id: "broken-reflections",
    title: "BROKEN REFLECTIONS",
    format: "LP",
    accent: "#B4232B",
    cover: `${A}/92prksim_IMG_7251.png`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/B3MRNvBO08zJHZtnd7jGh",
    tag: "FRACTURE",
    world: "A wall of open eyes that will not blink. The self split into versions, each certain it is the real one. Motifs return warped, watching themselves decay. A hall of mirrors with no way out.",
    lore: [
      "Built from loops that come back wrong. A phrase repeats, then repeats again with one detail changed, until you stop trusting which version was real.",
      "A record about being watched by your own past selves. None of them agree with you. All of them are you.",
    ],
  },
  {
    id: "4nvrlove",
    title: "4NVRLØVE LP",
    format: "LP",
    accent: "#7C68B0",
    cover: `${A}/gllua8dk_IMG_7250.png`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/3jDDG5g4PPzUli2nu3kdA",
    tag: "DISTANCE",
    world: "A white rose left to brown on a windowsill, filmed on a camcorder nobody rewound. The record already made up its mind about love. Cold pads, patient drums, a door closed quietly and for good.",
    lore: [
      "The title is a decision, not a mood. Four letters standing in for a promise to never do that again.",
      "The drums stay patient. The pads stay cold. Nothing here is trying to win anyone back, and that is exactly what makes it ache.",
    ],
  },
  {
    id: "the-way-out",
    title: "THE WAY OUT",
    format: "LP",
    accent: "#6E8FA6",
    cover: `${A}/8wp7ozsv_IMG_7290.png`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/nTutzHMyUC6RHIeBeYSQx",
    tag: "ESCAPE",
    world: "A door left open at the end of a long dark hallway. Not triumph. Just the first breath of air after holding it too long.",
    lore: [
      "The record that comes after the worst of it. The arrangement thins out, the low end lifts, and for the first time in a while there is somewhere to go.",
      "It does not pretend the damage is gone. It just points at the exit and lets you decide when to walk through it.",
    ],
  },
  {
    id: "bittersweet",
    title: "BITTERSWEET LP",
    format: "LP",
    accent: "#E11414",
    cover: `${A}/bcwhi15y_Love_Candy_Modern_Minimal_Music_Album_Cover_Art.png`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/9jUNjRYCZ2Dun0OP6W6wF",
    tag: "NOSTALGIA",
    world: "Black lipstick and a taste that lingers too long. Warm harmony leaning toward something it knows it shouldn't want. Pleasure and regret sharing one mouth. Slow, glossy, a little dangerous.",
    lore: [
      "Two flavors that refuse to separate. Warm chords that lean somewhere they shouldn't, then apologize in the next bar.",
      "It sounds expensive and a little guilty. The kind of night you enjoy and regret in the same breath.",
    ],
  },
  {
    id: "toxic-romance",
    title: "TOXIC ROMANCE",
    format: "LP",
    accent: "#4F9E5F",
    cover: `${A}/b2jhcrcn_IMG_7288.png`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/NiRaleZ66L1u0XxmcNagK",
    tag: "POISON",
    world: "The good part and the poison arrive in the same bar. Sweet on contact, sick by the end. A love you keep going back to knowing exactly how it ends.",
    lore: [
      "Built on a chord that never fully resolves. It leans in, promises something, then pulls the warmth out from under you.",
      "Attraction and damage wearing the same face. It knows it is bad for you. So do you. Neither of you stops.",
    ],
  },
  {
    id: "still-in-love",
    title: "STILL IN LOVE LP",
    format: "LP",
    accent: "#E1143F",
    cover: `${A}/77dskoba_IMG_7255.png`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/mcE5v6s8eMnLglYvYfvA7",
    tag: "LONGING",
    world: "Neon bleeding into smoke. It was always you, and the record will not stop saying it. Intimate, low, refusing to sober up. Holding on well past the point where holding on still helps.",
    lore: [
      "A record that will not take the hint. It circles the same name, the same room, the same few chords that felt like home.",
      "Low, close, and a little drunk. The sound of holding on long after everyone told you to let go.",
    ],
  },
  {
    id: "dont-fall-in-love",
    title: "DON'T FALL IN LOVE LP",
    format: "LP",
    accent: "#4A82A8",
    cover: `${A}/v7jxak4l_IMG_7254.png`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/eBCZ6aKadDiuv8kcLtBuI",
    tag: "WARNING",
    world: "A body falling into the only light in the room. A warning meant for no one and everyone. Calm on the surface, panicking underneath. Every instinct says stop. The beat keeps pulling down.",
    lore: [
      "A warning issued too late, to no one in particular. The surface stays calm. Underneath, everything is bracing for impact.",
      "Every instinct says step back from the edge. The rhythm keeps walking forward anyway.",
    ],
  },
  {
    id: "nvrl8isbtr",
    title: "NVRL8ISBTR EP — MEMORIES OF TOMORROW",
    format: "EP",
    accent: "#E8622A",
    cover: `${A}/nrkcqntv_Orange_and_Black_Handwritten_Vintage_cassette_tape_Album_Cover.png`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/anQVSFZouS7gZ23fcU7w5",
    tag: "FUTURE",
    world: "A cassette full of things you meant to say. I luv u. Will you stay. Not my type. Nostalgia recorded early and played back from a future that never showed. Warm, worn, quietly funny about its own heartbreak.",
    lore: [
      "A tape of feelings recorded before they happened. I luv u. Will you stay. Not my type. Small sentences that decide whole lives.",
      "It is nostalgic for a future that never arrived, and it knows it. Warm, worn, and quietly laughing at itself.",
    ],
  },
  {
    id: "beyond-the-abyss",
    title: "BEYOND THE ABYSS EP",
    format: "EP",
    accent: "#5E7C9C",
    cover: `${A}/i0lpmddw_IMG_7253.png`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/5fQWuKANFx5eA8R1F84Q2",
    tag: "DESCENT",
    world: "A single wing against the weight of everything. Pressure, then stillness, then the strange lightness of letting go. Music that sinks on purpose, until sinking starts to feel like flight.",
    lore: [
      "Down is the only direction. Pressure builds, the arrangement thins, and somewhere near the bottom the weight turns into something like weightlessness.",
      "The wing on the cover is not an escape. It is what is left after you stop fighting the fall.",
    ],
  },
  {
    id: "astral",
    title: "ASTRAL",
    format: "LP",
    accent: "#7C74C8",
    cover: `${A}/htsdrncb_IMG_7289.png`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/nuGqqmdCKDFPgbO42kTwG",
    tag: "WEIGHTLESS",
    world: "Weightless. The body stays behind and something else drifts up through the ceiling. Wide, slow, cold at the edges, like watching your own life from very far away.",
    lore: [
      "A record about leaving the body without meaning to. Long tones that hang in the air longer than they should, and drums that feel like a pulse heard from the next room.",
      "Not peaceful exactly. More like the quiet you find at high altitude, where the air is thin and everything you were worried about looks small.",
    ],
  },
  {
    id: "machina",
    title: "MACHINA & THE GHOST OF THE SOUND",
    format: "LP",
    accent: "#8B97A3",
    cover: `${A}/auxaoc2b_IMG_7184.jpeg`,
    preview: null,
    stream: null,
    url: "https://untitled.stream/buy/project/f5W0bCWurNtNn2H4AiI00",
    tag: "MACHINE SOUL",
    world: "MACHINA wants a soul. The Ghost is an artist the world ignored until he was gone. They meet in a city of rust, gears and buried dreams, and trade shelter for feeling. Almost no words. The harmony does the talking. Some dreams don't die peacefully. Some become ghosts.",
    lore: [
      "MACHINA is a machine that wants a soul. The Ghost is the spirit of an artist the world ignored while he was still alive to be ignored. They find each other in a city of gears, rust, steam and buried dreams.",
      "The machine gives the Ghost somewhere to live. The Ghost gives the machine the one thing it was never built to hold: feeling. What grows between them is closer to possession than friendship.",
      "There are almost no words. The story is carried by harmony, texture, distortion, silence and repetition. Some dreams don't die peacefully. Some become ghosts.",
    ],
  },
];

export const allAlbums = [...fullAlbums, ...instrumentalAlbums];

export const getAlbum = (id) => allAlbums.find((a) => a.id === id);
